import { render, staticRenderFns } from "./newRole.vue?vue&type=template&id=dfbbd928&"
import script from "./newRole.vue?vue&type=script&lang=js&"
export * from "./newRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports